import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'react-final-form'

import SplitButton from '~/components/Buttons/SplitButton'
import { SaveButton } from '~/components/Buttons'

import { SAVE_DRAFT, SAVE_COMPLETE } from '../../constants'

function AdjustmentCreateButton ({ onSubmit, isLoading }) {
  const submitTypeField = useField('submitType')
  const submitTypeFieldChange = submitTypeField.input.onChange

  const onClickSaveDraft = useCallback(() => {
    submitTypeFieldChange(SAVE_DRAFT)
    return onSubmit()
  }, [onSubmit, submitTypeFieldChange])

  const onClickSaveComplete = useCallback(() => {
    submitTypeFieldChange(SAVE_COMPLETE)
    return onSubmit()
  }, [onSubmit, submitTypeFieldChange])

  const splitButtonOptions = [
    {
      label: 'Save draft',
      button: (
        <SaveButton
          disabled={isLoading}
          children="Save draft"
          onClick={onClickSaveDraft}
          type="button"
        />
      ),
      'data-cy': 'saveDraftMenu',
      onMenuClick: () => onClickSaveDraft
    },
    {
      label: 'Save & complete',
      button: (
        <SaveButton
          data-cy="save-complete"
          disabled={isLoading}
          type="button"
          onClick={onClickSaveComplete}
          children="Save & complete"
        />
      ),
      'data-cy': 'saveCompleteMenu',
      onMenuClick: () => onClickSaveComplete()
    }
  ]

  return (
    <SplitButton
      name="adjustmentCreate"
      options={splitButtonOptions}
    />
  )
}

AdjustmentCreateButton.propTypes = {
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func
}

export default AdjustmentCreateButton
